import { closingTimeExist, clearTimerFromStorage, Source, getClosingTime } from "@swiggy-private/core-ui";
import { useCallback, useContext, useState, useMemo } from "react";
import {
    closingTImerHalfCardImpressionEvent,
    closingTImerImpressionEvent,
} from "@payment-client/analytics/events/ClosingTimer";
import {
    CheckoutContext,
    AnalyticsContext,
    CheckoutActionTypes,
    recordNREvent,
    NEWRELIC_TABLES,
} from "@swiggy-private/checkout-core";

interface UseCartTimerReturnType {
    canShowTimer: boolean;
    closeTime: number;
    onComplete: () => void;
    closingTimerSource: Source;
    onTimerLoad: () => void;
}

const useCartTimer = (): UseCartTimerReturnType => {
    const closingTimeinStorage = closingTimeExist();
    const closeTime = getClosingTime();
    const { checkoutState } = useContext(CheckoutContext);
    const { impressionEvent } = useContext(AnalyticsContext);
    const [canShowTimer, setCanShowTimer] = useState(closingTimeinStorage);

    const onComplete = useCallback(() => {
        clearTimerFromStorage();
        setCanShowTimer(false);
    }, []);

    const impressionClosingTimer = useCallback(() => {
        closingTImerImpressionEvent(impressionEvent);
    }, [impressionEvent]);

    const impressionClosingTimerHalfCard = useCallback(() => {
        closingTImerHalfCardImpressionEvent(impressionEvent);
    }, [impressionEvent]);

    const closingTimerSource = useMemo(() => {
        return checkoutState.type === CheckoutActionTypes.PAYMENT_FAILED ? Source.PAY_HALF_CARD : Source.PAYMENT;
    }, [checkoutState.type]);

    const closingTimerImpression = useMemo(() => {
        return checkoutState.type === CheckoutActionTypes.PAYMENT_FAILED
            ? impressionClosingTimerHalfCard
            : impressionClosingTimer;
    }, [checkoutState.type, impressionClosingTimer, impressionClosingTimerHalfCard]);

    const onTimerLoad = useCallback(() => {
        //TODO: Remove temporary new relic event added for cross-refrencing with analytics events after analysis
        recordNREvent({ eventType: NEWRELIC_TABLES.TIMER_RENDERED, referer: Source.PAYMENT });
        closingTimerImpression();
    }, [closingTimerImpression]);

    return {
        canShowTimer,
        closeTime,
        onComplete,
        closingTimerSource,
        onTimerLoad,
    };
};

export default useCartTimer;
